import { createContext, useContext, useState } from 'react';
import { JobContextData, JobData, JobProviderProps, ProjectState } from './types';
import { initialProjectState, initialState } from './constants';

export const JobContext = createContext<JobContextData | Record<string, never>>({});

export const JobProvider = ({ children, value }: JobProviderProps) => {
  const [state, setState] = useState<JobData>(initialState);
  const [projectState, setProjectState] = useState<ProjectState>(initialProjectState);

  return (
    <JobContext.Provider
      value={{ ...value, rescheduler: state, projectState, setState, setProjectState }}>
      {children}
    </JobContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useJobContext = () => useContext(JobContext);
